<div>
    <div class="flex flex_row flex_sb">
        <div class="fw-600 wd-80"> {{ 'SHARED.PAYMENT_PROCESSING' | fallbackTranslate }} ({{currency}} {{plAmount?.toFixed(2)}})</div>
        <div class="maximize-cls"><img [src]="images.PINE_LAB_MAX_ICON" alt="image"/></div>
    </div>
    <div class="flex flex_row flex_sb">
        <div class="wd-80 m-r-5">  
        <nz-progress
         [nzPercent]="percentageElapsed"
         [nzShowInfo]="false"
         class="flex-1"
      ></nz-progress>
      </div>
      <div class="flex flex_row">
      <nz-countdown  [nzValue]="deadlineDate" [nzFormat]="'mm:ss'"></nz-countdown> <div class="p-l-5 black-clr p-t-3 fw-600">mins</div>
      </div>
    </div>
</div>    